export const translationOrganizations_da_part2 = {
  orgDetailUnableToLoadOrganization: "Kunne ikke indlæse organisationen.",
  orgDetailKnowledgeBaseIndexesMustBeArray: "Vidensbase-indexes skal være et JSON-array.",
  orgDetailSettingsSaved: "Organisationens indstillinger er gemt.",
  orgDetailUnableToSaveSettings: "Kunne ikke gemme organisationens indstillinger.",
  orgDetailChatbotAttached: "{chatbotId} er tilknyttet denne organisation.",
  orgDetailChatbotDetached: "Tilknytningen af {chatbotId} til denne organisation er fjernet.",
  orgDetailPaymentEventAdded: "Betalingshændelsen er tilføjet.",
  orgDetailPaymentEventSaved: "Betalingshændelsen er gemt.",
  orgDetailUnableToSavePaymentEvent: "Kunne ikke gemme betalingshændelsen.",
  orgDetailDeletePaymentEventTitle: "Slet denne betalingshændelse?",
  orgDetailPaymentEventDeleted: "Betalingshændelsen er slettet.",
  orgDetailUnableToDeletePaymentEvent: "Kunne ikke slette betalingshændelsen.",
  orgDetailInviteRoleTitle: "Inviter {role} til organisationen?",
  orgDetailInviteRoleWarning:
    "Du er ved at give {email} {role}-adgang i denne organisation. {description} Vil du fortsætte?",
  orgDetailThisEmail: "denne e-mail",
  orgDetailSendInvite: "Send invitation",
  orgDetailInvitationSent: "Invitationen er sendt.",
  orgDetailUnableToSendInvitation: "Kunne ikke sende invitationen.",
  orgDetailInvitationResent: "Invitationen er sendt igen.",
  orgDetailUnableToResendInvitation: "Kunne ikke gensende invitationen.",
  orgDetailInvitationCancelled: "Invitationen er annulleret.",
  orgDetailUnableToCancelInvitation: "Kunne ikke annullere invitationen.",
  orgDetailCannotChangeOwnRole: "Du kan ikke ændre din egen rolle.",
  orgDetailMemberRoleUpdated: "Medlemmets rolle er opdateret.",
  orgDetailUnableToUpdateMemberRole: "Kunne ikke opdatere medlemmets rolle.",
  orgDetailCannotRemoveSelf: "Du kan ikke fjerne dig selv fra denne organisation.",
  orgDetailRemoveMemberTitle: "Fjern dette medlem?",
  orgDetailRemoveMemberWarning:
    "Vil du fjerne dette medlem fra organisationen? Brugerkontoen forbliver aktiv og kan stadig være medlem af andre organisationer.",
  orgDetailMemberRemoved: "Medlemmet er fjernet.",
  orgDetailUnableToRemoveMember: "Kunne ikke fjerne medlemmet.",
  orgDetailCannotDeleteOwnAccount: "Du kan ikke slette din egen konto.",
  orgDetailDeleteUserTitle: "Slet denne brugerkonto?",
  orgDetailDeleteUserWarning:
    "Vil du permanent slette denne bruger fra identitetssystemet? Det fjerner al organisationsadgang og kan ikke fortrydes. Tilknyttede lokale dashboard-data bevares.",
  orgDetailDeleteUserConfirmLabel: "Slet bruger",
  orgDetailUserDeleted: "Brugeren er slettet.",
  orgDetailUnableToDeleteUser: "Kunne ikke slette brugeren.",
  orgDetailMembersTitle: "Medlemmer",
  orgDetailMembersDescription:
    "Tildel Medlem, Manager, Udvikler, Support eller Analytiker for at styre, hvilke sider et medlem kan bruge.",
  orgDetailMembersAdminNote:
    "Admins kan også tildele eller fjerne Ejer og permanent slette brugere.",
  orgDetailOwnerAccessLockedNote: "Ejer-adgang kan ikke ændres her.",
  orgDetailOwnerAccessLocked: "Ejer-adgang kan ikke ændres her",
  orgDetailMembersCount: "{count} medlemmer",
  orgDetailNoMembersFound: "Der blev ikke fundet medlemmer i denne organisation.",
  orgDetailTableMember: "Medlem",
  orgDetailTableEmail: "E-mail",
  orgDetailTableRole: "Rolle",
  orgDetailTableAccess: "Adgang",
  orgDetailTableActions: "Handlinger",
  orgDetailNoEmailAvailable: "Ingen e-mail tilgængelig",
  orgDetailSelfLockNotice:
    "Du kan ikke ændre din egen rolle, fjerne dig selv eller slette din egen konto",
  orgDetailRemoveTooltip: "Fjern fra denne organisation",
  orgDetailDeleteUser: "Slet bruger",
  orgDetailDeleteUserTooltip: "Slet denne brugerkonto",
  orgDetailInviteTeamMember: "Inviter teammedlem",
  orgDetailInviteDescription:
    "Invitationer med en anden rolle end Medlem kræver bekræftelse, før invitationen sendes.",
  orgDetailEmailLabel: "E-mail",
  orgDetailFirstNameLabel: "Fornavn",
  orgDetailFirstNamePlaceholder: "Fornavn",
  orgDetailLastNameLabel: "Efternavn",
  orgDetailLastNamePlaceholder: "Efternavn",
  orgDetailRoleLabel: "Rolle",
  orgDetailSending: "Sender...",
  orgDetailSendInvitation: "Send invitation",
  orgDetailInvitationsTitle: "Invitationer",
  orgDetailNoInvitationsFound: "Ingen invitationer fundet.",
  orgDetailExpired: "Udløbet",
  orgDetailExpiresInHourSingular: "Udløber om {hours} time",
  orgDetailExpiresInHoursPlural: "Udløber om {hours} timer",
  orgDetailBusinessTitle: "Forretning",
  orgDetailBusinessDescription:
    "Følg den månedlige tilbagevendende omsætning via daterede stigninger, fald og churn.",
  orgDetailCurrentMonthlyPayment: "Nuværende månedlig betaling",
  orgDetailEditPaymentEvent: "Rediger betalingshændelse",
  orgDetailAddPaymentEvent: "Tilføj betalingshændelse",
  orgDetailAmountDeltaLabel: "Beløbsændring (kr)",
  orgDetailAmountDeltaPlaceholder: "Brug negative værdier for reduktioner",
  orgDetailEventDateLabel: "Dato for hændelse",
  orgDetailNoteLabel: "Note",
  orgDetailNotePlaceholder: "Kontraktændring, churn-årsag, rabat osv.",
  orgDetailCancelEdit: "Annuller redigering",
  orgDetailSaveEvent: "Gem hændelse",
  orgDetailAddEvent: "Tilføj hændelse",
  orgDetailPaymentEventsTitle: "Betalingshændelser",
  orgDetailNoPaymentEvents: "Ingen betalingshændelser registreret.",
  orgDetailEventTypeChurn: "Churn",
  orgDetailEventTypeDecrease: "Fald",
  orgDetailEventTypeIncrease: "Stigning",
  orgDetailPaymentAfterEvent: "Betaling efter hændelse: {amount}",
  orgDetailSettingsTitle: "Organisationsindstillinger",
  orgDetailSettingsDescription:
    "Realm-admins kan opdatere organisationsindstillinger her. Værdierne gemmes på organisationen i stedet for på en enkelt bruger.",
  orgDetailDangerZoneTitle: "Farezone",
  orgDetailDangerZoneDescription:
    "Sletning af organisationen fjerner den fra Keycloak og sletter alle tilknyttede chatbots permanent.",
  orgDetailDeleteOrganization: "Slet organisation",
  orgDetailDeletingOrganization: "Sletter organisation...",
  orgDetailDeleteOrganizationSummary:
    '"{name}" har {count} tilknyttede chatbot(s). Denne handling kan ikke fortrydes.',
  orgDetailDeleteOrganizationTitle: 'Slet organisationen "{name}"?',
  orgDetailDeleteOrganizationWarning:
    'Organisationen "{name}" og dens {count} tilknyttede chatbot(s) ({chatbots}) slettes permanent. Medlemskonti slettes ikke.',
};
